import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/account.css";

const LINKS = [
  { to: "/account", label: "My Account", icon: "ph-user" },
  { to: "/address-book", label: "Address Book", icon: "ph-map-pin" },
  { to: "/my-orders", label: "My Orders", icon: "ph-package" },
];

// Account section navigation: a side card on desktop, a row of swipeable tabs on phones.
const AccountSidebar = () => (
  <nav className="account-nav" aria-label="My account">
    <span className="account-nav__title">My account</span>
    {LINKS.map(({ to, label, icon }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) => `account-nav__link${isActive ? " is-active" : ""}`}
      >
        <i className={`ph ${icon}`} aria-hidden="true" />
        {label}
      </NavLink>
    ))}
  </nav>
);

export default AccountSidebar;
